export const AnswerLabelsForAnalytics: Record<number, string> = {
  22: "Two or more keys",
  23: "One Key",
  32: "Vehicle usage - Yes",
  33: "Vehicle usage - No",
  34: "No imperfections",
  39: "No. Tyres need replaced",
  59: "No. Wheels need replaced",
  47: "No mechanical issues",
  83: "Warning lights",
  84: "Electrical fault",
  85: "Unusual noise",
  66: "Non runner"
};
